import * as Styled from "./styled";
import { HeaderProps } from "./types";

const Header: React.FC<React.PropsWithChildren<HeaderProps>> = ({
  title,
  loading,
  children,
}) => (
  <Styled.Header {...{ loading }}>
    {loading ? (
      <Styled.TitleSkeleton />
    ) : (
      <>
        {title && <Styled.Title>{title}</Styled.Title>}
        {children}
      </>
    )}
  </Styled.Header>
);

export default Header;
